import { render, staticRenderFns } from "./showcaseCell.vue?vue&type=template&id=6086e106&scoped=true"
import script from "./showcaseCell.vue?vue&type=script&lang=js"
export * from "./showcaseCell.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6086e106",
  null
  
)

export default component.exports